import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Chip, Stack, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useQuery } from '@apollo/client/react';
import gql from 'graphql-tag';
import Link from 'next/link';
import moment from 'moment';
import { withApollo } from '../../../hoc/withApollo';

const useStyles = makeStyles()((theme) => ({
  cardTitle: {
    color: '#2C367E',
    fontFamily: theme.typography.h5.fontFamily,
    textTransform: 'uppercase',
    fontWeight: '400',
    textAlign: 'center',
    fontSize: '3em',
    [theme.breakpoints.down('md')]: { fontSize: '1.6em' },
  },
  border: {
    width: '3em',
    borderColor: '#2C367E',
    borderBottom: 'solid',
    marginLeft: '48%',
    borderBottomColor: '#2C367E',
    height: '1em',
  },
  section: {
    paddingTop: '5em',
    paddingBottom: '5em',
    textAlign: 'center',
    backgroundColor: '#fdfaf0',
  },
  buttonGrid: {
    fontSize: '1.1em',
    margin: '2em 0 0.5em 0',
    color: 'white',
    backgroundColor: '#d96552',
    border: 'none',
    fontWeight: 'bold',
    borderRadius: '1.5em',
    padding: '0.6em 2.5em',
    cursor: 'pointer',
    '&:hover': {
      color: '#d96552',
      backgroundColor: 'white',
      border: '2px solid #d96552',
    },
  },
}));

const QUERY = gql`
  query petitesAnnonces($limit: Int, $sort: String, $way: String) {
    petitesAnnonces(limit: $limit, sort: $sort, way: $way, onlyValidated: true) {
      id
      title
      shortDescription
      type
      city
      url
      createdAt
      actor {
        id
        name
        url
      }
      user {
        id
        surname
        lastname
      }
    }
  }
`;

interface Props {
  id?: string;
}

const LastPetitesAnnonces: React.FC<Props> = ({ id }) => {
  const { classes: styles } = useStyles();
  const { data } = useQuery<any>(QUERY, {
    variables: { limit: 6, sort: 'createdAt', way: 'DESC' },
  });
  const annonces = data?.petitesAnnonces || [];

  return (
    <Container className={styles.section} id={id} maxWidth={false}>
      <Typography variant="h5" className={styles.cardTitle}>
        DERNIÈRES PETITES ANNONCES
      </Typography>
      <div className={styles.border} />
      <Typography variant="body2" sx={{ mt: 2, mb: 3, color: 'text.secondary' }}>
        Dons, échanges, entraide, mutualisation — pour la transition écologique et solidaire.
      </Typography>

      <Container maxWidth="lg" sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          {annonces.slice(0, 6).map((a: any) => (
            <Grid item xs={12} sm={6} md={4} key={a.id}>
              <Card variant="outlined" sx={{ height: '100%', textAlign: 'left' }}>
                <CardContent>
                  <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                    <Chip
                      size="small"
                      label={a.type === 'offre' ? 'Offre' : 'Demande'}
                      color={a.type === 'offre' ? 'success' : 'warning'}
                    />
                  </Stack>
                  <Link href={`/petites-annonces/${a.url}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography variant="h6">{a.title}</Typography>
                  </Link>
                  <Typography variant="caption" color="text.secondary">
                    {moment(parseInt(String(a.createdAt))).fromNow()}
                    {a.city ? ` · ${a.city}` : ''}
                  </Typography>
                  {a.shortDescription && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {a.shortDescription}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
          {annonces.length === 0 && (
            <Grid item xs={12}>
              <Typography color="text.secondary">Aucune annonce pour le moment — soyez le premier !</Typography>
            </Grid>
          )}
        </Grid>
        <Box>
          <Link href="/petites-annonces">
            <button className={styles.buttonGrid}>VOIR TOUTES LES PETITES ANNONCES</button>
          </Link>
          <Box sx={{ mt: 1 }}>
            <Link href="/petites-annonces/nouveau" style={{ color: '#2c367e', fontWeight: 'bold' }}>
              + Publier votre annonce
            </Link>
          </Box>
        </Box>
      </Container>
    </Container>
  );
};

export default withApollo()(LastPetitesAnnonces);
